module.exports = __webpack_public_path__ + "img/ico-education.c49577f3.svg";